import * as React from "react";
import styles from "./styles.module.scss";
import { EventVendorQuery } from "@src/@types/api.d";
import Icon from "@src/components/Icon";
import { decodeHtmlEntities } from "@src/utils/general";

type Props = {
  eventId: number;
  eventVendorData: EventVendorQuery;
};

const Vendors: React.FC<Props> = ({ eventId, eventVendorData }) => {
  return !!eventVendorData?.eventVendor &&
    eventVendorData?.eventVendor?.length > 0 ? (
    <div className="px-4 bg-[#EBE3CE]">
      <section className="border-b-4 py-2 border-b-[#8C7756] font-inter">
        <div className="border-y border-y-[#8C7756] flex flex-col gap-4 md:flex-row md:gap-12 justify-center items-center py-[5rem] flex-wrap">
          {eventVendorData?.eventVendor?.map((vendor, index) => {
            const decodedName = decodeHtmlEntities(vendor?.name);
            const decodedRole = decodeHtmlEntities(vendor?.role);
            const decodedEmail = decodeHtmlEntities(vendor?.email);
            const decodedInstagramHandle = decodeHtmlEntities(
              vendor?.instagram_handle
            );

            return (
              <div
                key={`vendors-home-page-${index}`}
                className="p-4 flex flex-col justify-center items-center gap-4 text-[#4B4838] lg:gap-6"
              >
                <h1 className="text-lg">{decodedName}</h1>
                <p className="">{decodedRole}</p>
                <p className="">{decodedEmail}</p>
                <div className="">
                  {/* <div className={styles["home__social-icon"]}>
                  <Icon iconName="facebook" />
                </div>
                <div className={styles["home__social-icon"]}>
                  <Icon iconName="twitter" />
                </div> */}
                  {!!decodedInstagramHandle && (
                    <a
                      target="_blank"
                      href={
                        decodedInstagramHandle.includes("@")
                          ? `https://www.instagram.com/${
                              decodedInstagramHandle.split("@")[1]
                            }/`
                          : `https://www.instagram.com/${decodedInstagramHandle}/`
                      }
                      rel="noopener noreferrer"
                      className="text-[#4B4838]"
                    >
                      <Icon iconName="instagram" />
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  ) : (
    <></>
  );
};

export default Vendors;
